import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PropertyCard } from "@/components/PropertyCard";
import { useAuth } from "@/context/AuthContext";
import { Heart } from "lucide-react";

export const Favorites = ({ onAuth }) => {
  const { user } = useAuth();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) { setLoading(false); return; }
    api.get("/favorites").then(({ data }) => setList(data)).finally(() => setLoading(false));
  }, [user]);

  if (!user) {
    return (
      <div className="max-w-xl mx-auto px-6 py-20 text-center">
        <Heart className="w-10 h-10 mx-auto text-[var(--primary)]" />
        <h1 className="font-serif text-3xl text-[var(--teak)] mt-4">Sign in to view your favorites</h1>
        <button className="btn-primary mt-6" onClick={() => onAuth?.("login")} data-testid="fav-signin-btn">Sign In</button>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-10">
      <div className="mb-8">
        <span className="section-eyebrow">Your shortlist</span>
        <h1 className="font-serif text-4xl text-[var(--teak)] mt-2">Saved Properties</h1>
      </div>
      {loading ? (
        <div className="text-center text-[var(--ink-muted)] py-10">Loading...</div>
      ) : list.length === 0 ? (
        <div className="text-center py-20 text-[var(--ink-muted)]">You haven&apos;t saved any properties yet.</div>
      ) : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {list.map((p, i) => <PropertyCard key={p.id} property={p} index={i} isFavorite />)}
        </div>
      )}
    </div>
  );
};
